// src/contexts/SentryErrorContext.tsx
import { createContext, useContext, useState } from "react";

type SentryErrorContextType = {
  eventId: string | null;
  setEventId: (id: string | null) => void;
};

const SentryErrorContext = createContext<SentryErrorContextType | undefined>(
  undefined,
);

export const SentryErrorProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [eventId, setEventId] = useState<string | null>(null);

  return (
    <SentryErrorContext.Provider value={{ eventId, setEventId }}>
      {children}
    </SentryErrorContext.Provider>
  );
};

export const useSentryError = () => {
  const context = useContext(SentryErrorContext);
  if (!context) {
    throw new Error("useSentryError must be used inside SentryErrorProvider");
  }
  return context;
};
